import React, { useEffect } from "react";
import { ApolloProvider } from "@apollo/client";
import { clientUserPool } from "./apollo/client";
import DayJsUtils from "@date-io/dayjs";
import { BrowserRouter } from "react-router-dom";
import Router, { ScrollToTop } from "./router/index.js";
import axios from "axios";
//import "./styles/index.css";
import { Amplify } from "aws-amplify";
// import config from "./aws-exports";
Amplify.configure(AWS);
import { Suspense } from "react";
import th from "dayjs/locale/th";
import en from "dayjs/locale/en-au";
import { maintenanceDetail, isMaintenance } from "./apollo/cache";
import { getMaintenance } from "./_services";

import { RecoilRoot } from "recoil";

import ReactGA from "react-ga4";
import { TrackJS } from "trackjs";

if (APP_ENV === "production") {
  ReactGA.initialize(GA_ID, {
    gaOptions: {
      siteSpeedSampleRate: 100,
    },
  });
  TrackJS.install({
    token: "b92c196d35434ebc98b61683e9064925",
    application: "m0",
    version: APP_VERSION
  });
}

// import Rehydrated from "./Rehydrated";
// import { Rehydrated } from 'aws-appsync-react'

import { DialogProvider } from "./context/Dialog";
import { AppContextProvider } from "./context/AppContextProvider";

import GetData from "./getData";

import ErrorBoundary from "./ErrorBoundary";

import { SnackbarProvider } from "notistack";
import Slide from "@mui/material/Slide";
import ConnectionDetector from "pages/NoInternetConnection";

import { thTH, enUS } from "@mui/material/locale";
import { useTranslation } from "react-i18next";
import { checkLanguage } from "utility";
import dayjs from "dayjs";

import { makeStyles } from "@mui/styles";
import { GlobalStyles } from "@mui/material";
const useStyles = makeStyles(() => ({
  anchorOriginTopRight: {
    top: "70px !important",
  },
}));

// scroll bar
import "simplebar-react/dist/simplebar.min.css";
import ThemeProvider from "./theme";

import { QueryClient, QueryClientProvider } from "react-query";
import WhatIsNew from "WhatIsNew";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { APP_ENV, APP_VERSION, AWS, GA_ID, ROUTE_BASENAME } from "config";

import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { store, persistor } from "./redux/store";


const queryClient = new QueryClient({
  defaultOptions: {},
});

function App() {
  const classes = useStyles();
  const { i18n, t } = useTranslation("", { useSuspense: false });

  useEffect(() => {
    // axios.defaults.headers.common["language"] = i18n.language; // for all requests
    // i18n.changeLanguage(localStorage.language || i18n.language);
    if (i18n.language) {
      axios.defaults.headers.common = { language: checkLanguage(i18n.language) };
      dayjs.locale(checkLanguage(i18n.language));
      document.body.style.fontFamily =
        checkLanguage(i18n.language) !== "vi" ? "Prachason" : "Inter";
      getMaintenance().then(({ data }) => {
        maintenanceDetail(data);
        isMaintenance(data.state);
      });
    }
  }, [i18n.language]);

  return (
    <>
      <GlobalStyles styles={{ html: { fontSize: i18n.language === "vi" ? 14 : 16 } }} />
      <QueryClientProvider client={queryClient}>
        <ReduxProvider store={store}>
          <BrowserRouter basename={ROUTE_BASENAME}>
            <ScrollToTop />
            <PersistGate loading={null} persistor={persistor}>
              <ThemeProvider locale={i18n.language === "th" ? thTH : enUS}>
                <ApolloProvider client={clientUserPool}>
                  <RecoilRoot>
                    <Suspense fallback={<div />}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        utils={DayJsUtils}
                        dateFormats={{
                          year: t("formatDate.fullYear"),
                          keyboardDate: t("formatDate.keyboardDate"),
                        }}
                        locale={i18n.language === "th" ? th : en}
                      >
                        <DialogProvider>
                          <ErrorBoundary>
                            <GetData>
                              <AppContextProvider>
                                <ConnectionDetector>
                                  <SnackbarProvider
                                    maxSnack={3}
                                    anchorOrigin={{
                                      vertical: "top",
                                      horizontal: "right",
                                    }}
                                    classes={{
                                      containerAnchorOriginTopRight: classes.anchorOriginTopRight,
                                    }}
                                    TransitionComponent={Slide}
                                  >
                                    <div style={{ minHeight: "calc(100vh - 44px)" }}>
                                      <Router />
                                      <WhatIsNew />
                                    </div>
                                  </SnackbarProvider>
                                </ConnectionDetector>
                              </AppContextProvider>
                            </GetData>
                          </ErrorBoundary>
                        </DialogProvider>
                      </LocalizationProvider>
                    </Suspense>
                  </RecoilRoot>
                </ApolloProvider>
              </ThemeProvider>
            </PersistGate>
          </BrowserRouter>
        </ReduxProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
